export const SET_HELPERS = "SET_HELPERS";
export const SET_USER = "SET_USER";
export const SET_DATE = "SET_DATE";
export const DELETE_SERVICE = "DELETE_SERVICE";
export const SET_RESERVATIONID = "SET_RESERVATIONID";
export const RESET_STORE = "RESET_STORE";
export const RESET_SERVICES = "RESET_SERVICES";